module.exports = __webpack_public_path__ + "media/images/career_camp/2022/dividers/footer_mountains-adf60e96a65f6f23e1171ea37ad15e3c.svg";